import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";

export default function PerformanceMarketing() {
  return (
    <div className="Performance-Marketing pt-[160px] sm:pt-0">
      <Helmet>
        <title>Top Performance Marketing Agency in Dubai | Mean3</title>
        <meta
        name="description"
        content="Get custom e-commerce performance marketing services in Dubai. Mean3 helps brands grow fast with paid ads, expert targeting, and conversion-driven strategies."
        />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
    </div>
  );
}
